// extracted by mini-css-extract-plugin
export default {"Emoji":"bbi_a bhi_i bhi_q bhi_j"};